import type { OnboardingDict } from '../en/onboarding';

export const onboarding: OnboardingDict = {
  controls: {
    next: 'Nästa',
    back: 'Tillbaka',
    done: 'Klar',
    skip: 'Hoppa över',
  },
  help: {
    menuLabel: 'Hjälp & tips',
    restartWelcome: 'Starta om välkomstturen',
    takeTour: {
      welcome: 'Tur: grunderna',
      review: 'Tur: granska ett dokument',
      playbooks: 'Tur: playbooks',
    },
  },
  tours: {
    welcome: {
      newChat: {
        title: 'Starta en konversation',
        body: 'Börja en ny chatt med QAgent – ställ en fråga, klistra in text eller släpp in ett dokument för granskning.',
      },
      newContract: {
        title: 'Skapa från grunden',
        body: 'Generera ett första utkast av ett avtal eller juridiskt dokument, steg för steg.',
      },
      projects: {
        title: 'Organisera ditt arbete',
        body: 'Samla dokument, playbooks och chattar i projekt så att allt för ett ärende finns på ett ställe.',
      },
      playbooks: {
        title: 'Dina playbooks',
        body: 'Playbooks är återanvändbara uppsättningar granskningsregler. Tillämpa en så kontrollerar QAgent ett dokument mot dina standarder.',
      },
      messageBox: {
        title: 'Fråga vad som helst',
        body: 'Skriv här för att chatta med QAgent – granska en klausul, fråga om skyldigheter eller begär ändringar.',
      },
      prompts: {
        title: 'Snabbstart',
        body: 'Osäker på var du ska börja? Välj något av de här för att komma igång.',
      },
      dropZone: {
        title: 'Släpp ett dokument',
        body: 'Dra en Word-, PDF- eller textfil var som helst här för att bifoga den och starta en granskning.',
      },
      installWord: {
        title: 'Använd det i Word',
        body: 'Föredrar du att arbeta i Microsoft Word? Installera Queri-tillägget för att granska och markera direkt i ditt dokument.',
      },
      userMenu: {
        title: 'Inställningar & språk',
        body: 'Växla mellan engelska och svenska, spela upp turerna igen eller logga ut härifrån.',
      },
      finish: {
        title: 'Då är du redo',
        body: 'Det var hela turen! Du kan spela upp den när som helst via ”Hjälp & tips” i menyn nedan.',
      },
    },
    review: {
      mention: {
        title: 'Hänvisa till filer & playbooks',
        body: 'Skriv ”@” i meddelanderutan för att peka QAgent mot en specifik fil eller playbook i projektet.',
      },
      resources: {
        title: 'Projektresurser',
        body: 'Öppna den här panelen för att se filerna och playbooks som QAgent använder, och för att ladda upp fler.',
      },
      suggestion: {
        title: 'Granska förslag',
        body: 'QAgent föreslår ändringar som förslag. Godkänn de du vill ha och avvisa resten – inget ändras förrän du bestämmer.',
      },
      export: {
        title: 'Exportera med dina ändringar',
        body: 'När du är nöjd laddar du ner dokumentet med de godkända ändringarna tillämpade.',
      },
    },
    playbooks: {
      intro: {
        title: 'Playbooks',
        body: 'En playbook är en återanvändbar uppsättning regler som QAgent använder för att granska ett dokument mot dina standarder.',
      },
      create: {
        title: 'Skapa en playbook',
        body: 'Bygg en från grunden: ge den ett namn och en avtalstyp och lägg sedan till regler — varje regel är en instruktion som QAgent följer vid granskning.',
      },
      import: {
        title: 'Importera en checklista',
        body: 'Har du redan dina standarder i ett dokument eller kalkylark? Importera det så gör QAgent om det till en playbook med regler.',
      },
      ai: {
        title: '…eller låt AI skapa en',
        body: 'Har du ett exempelavtal? Låt QAgent läsa det och generera en playbook att börja med som du kan finjustera.',
      },
      apply: {
        title: 'Använd en playbook',
        body: 'För att granska ett dokument mot en playbook, öppna en chatt och skriv ”@” för att referera till den — QAgent går igenom dokumentet regel för regel och föreslår ändringar.',
      },
    },
  },
  tips: {
    dropDocument: {
      title: 'Tips',
      body: 'Dra ett dokument var som helst på den här skärmen för att starta en granskning.',
    },
    mention: {
      title: 'Tips',
      body: 'Skriv ”@” för att hänvisa till en specifik fil eller playbook.',
    },
    dismiss: 'Uppfattat',
  },
};
